import React, { } from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { home } from "../../const";
import NavbarWithDrawer from "./NavbarWithDrawer";
import Footer from "./Footer";

const TermsOfService = () => {
  let width = window.innerWidth;
  return (
    <>
    {localStorage.getItem('x-auth-token') && <NavbarWithDrawer/>}
      <div className={`container-fluid ${localStorage.getItem('x-auth-token') && 'mt-5'}`}>
        <div className="p-5 mbl-pedding-10">
          {/* <Row>
            <Col md={12} className="text-center">
              <Link to={home}>
                <img
                  className={`${width > 468 ? `w-10` : `w-50`}`}
                  src={siteLogo}
                  alt={"Site Logo"}
                />
              </Link>
            </Col>
          </Row> */}
          <Row className="mt-4">
            <Col md={12}>
                <h1 className="mb-4">Term & Conditions</h1>
              <p>By using {process.env.REACT_APP_SITE_NAME}, you agree to the following:</p>
              <p>You must register using a valid mobile number and OTP.</p>
              <p>You can only communicate with the team leaders.</p>
              <p>You must not use the app for illegal or harmful purposes.</p>
              <p>The admin reserves the right to restrict or remove access if misuse is detected.</p>
              <p>Team Leaders can communicate with each other and with users who signup on the app.</p>
              <p>We reserve the right to update these terms at any time. Continued use of the app means you agree to the latest terms.</p>
              <p>For questions, email {process.env.REACT_APP_SUPPORT_EMAIL}</p>
            </Col>
          </Row>
        </div>
      </div>
     {localStorage.getItem("x-auth-token") && <Footer />}
    </>
  );
};

export default TermsOfService;
